// Константы и справочники для модуля кодов маркировки (КМ) - Пользовательский интерфейс
import { UserFilterStatusOption, UserFilterTypeOption } from './types';

export const API_BASE = process.env.REACT_APP_DOCUMENTS_API_URL || 'https://tbl.zerdegroup.kz/api/v1';
export const APP_VERSION = process.env.REACT_APP_DOC_VERSION || '1.0.9';

export const DEFAULT_USER_KM_TYPES: UserFilterTypeOption[] = [
  { zid: 'all', nameRu: 'Все' },
  { zid: 4, nameRu: 'Возврат в НПО' },
  { zid: 5, nameRu: 'Перемещение между аптеками' }
];

export const DEFAULT_USER_KM_STATUSES: UserFilterStatusOption[] = [
  { zid: 'all', nameRu: 'Все' },
  { zid: 3, nameRu: 'Принят' },
  { zid: 6, nameRu: 'В пути' },
  { zid: 7, nameRu: 'В работе' },
  { zid: 16, nameRu: 'Завершен' },
  { zid: 5, nameRu: 'Отклонен' },
  { zid: 9, nameRu: 'Черновик' },
  { zid: 15, nameRu: 'Ожидает подтверждения' },
  { zid: 12, nameRu: 'Ожидание сканирования коробов' },
  { zid: 11, nameRu: 'Ошибка остатка' },
  { zid: 14, nameRu: 'Ошибка 1С' }
];

export const USER_STATUS_COLORS: Record<string | number, 'success' | 'info' | 'warning' | 'primary' | 'error' | 'default'> = {
  3: 'info',
  'Принят': 'info',
  6: 'warning',
  'В пути': 'warning',
  7: 'primary',
  'В работе': 'primary',
  'В обработке': 'primary',
  16: 'success',
  'Завершен': 'success',
  5: 'error',
  'Отклонен': 'error',
  11: 'error',
  'Ошибка остатка': 'error',
  14: 'error',
  'Ошибка 1С': 'error',
  9: 'default',
  'Черновик': 'default',
  15: 'warning',
  'Ожидает подтверждения': 'warning',
  12: 'info',
  'Ожидание сканирования коробов': 'info'
};
